'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var composeActionName = exports.composeActionName = function composeActionName(names) {
  if (!names) {
    return '';
  }

  if (!Array.isArray(names)) {
    return '';
  }

  return names.join('_');
};